const MAX_RADIUS: number = 11;
const DOT_RADIUS: number = 2;
const VIEWBOX_SIZE = 2 * MAX_RADIUS;

class DotButton {
  button: HTMLButtonElement;

  /* ---- start of constructor functions ---- */
  constructor(
    themeColours: string[],
    id: string,
    onMouseoverCallback: Function,
    onMouseoutCallback: Function,
    onMouseclickCallback: Function
  ) {
    this.button = this.dotButtonCreate(themeColours, `dot-button--${id}`);
    this.button.addEventListener("click", (event) => {
      onMouseclickCallback(id);
    });
    this.button.addEventListener("mouseenter", (event) => {
      onMouseoverCallback(id);
    });
    this.button.addEventListener("focus", (event) => {
      onMouseoverCallback(id);
    });
    this.button.addEventListener("mouseleave", (event) => {
      onMouseoutCallback(id);
    });
    this.button.addEventListener("blur", (event) => {
      onMouseoutCallback(id);
    });
  }

  private createSVGCircle(colour: string, radius: number) {
    let circle = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "circle"
    );
    circle.setAttribute("cx", `${VIEWBOX_SIZE / 2}`);
    circle.setAttribute("cy", `${VIEWBOX_SIZE / 2}`);
    circle.setAttribute("r", `${radius}`);
    circle.setAttribute("fill", `${colour}`);
    return circle;
  }

  private createSVG(themeColours: string[]) {
    let svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("viewBox", `0 0 ${VIEWBOX_SIZE} ${VIEWBOX_SIZE}`);
    svg.setAttribute("height", "100%");
    svg.setAttribute("width", "100%");
    if (themeColours.length === 4) {
      svg.appendChild(this.createSVGCircle(themeColours[3], MAX_RADIUS));
      svg.appendChild(this.createSVGCircle(themeColours[2], 9));
      svg.appendChild(this.createSVGCircle(themeColours[1], 6));
      svg.appendChild(this.createSVGCircle(themeColours[0], 4));
    }
    if (themeColours.length === 3) {
      svg.appendChild(this.createSVGCircle(themeColours[2], MAX_RADIUS));
      svg.appendChild(this.createSVGCircle(themeColours[1], 8));
      svg.appendChild(this.createSVGCircle(themeColours[0], 5));
    }
    if (themeColours.length === 2) {
      svg.appendChild(this.createSVGCircle(themeColours[1], MAX_RADIUS));
      svg.appendChild(this.createSVGCircle(themeColours[0], 7));
    }
    svg.appendChild(this.createSVGCircle("white", DOT_RADIUS));
    return svg;
  }

  private dotButtonCreate(themeColours: string[], buttonId: string) {
    let svgCircle = this.createSVG(themeColours);
    let button = document.createElement("button");
    button.setAttribute("id", buttonId);
    button.setAttribute("class", "dot-button--default");
    button.appendChild(svgCircle);
    return button;
  }
  /* ---- end of constructor ---- */

  get buttonNode() {
    return this.button;
  }

  public setDisabledState(isDisabled: boolean) {
    this.button.disabled = isDisabled;
  }

  public setPosition(x: number, y: number, r: number) {
    this.button.style.left = `${x - r}px`;
    this.button.style.top = `${y - r}px`;
  }
}

export { DotButton };
